<template>
  <div class="page-content"  id="specialTreatment">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>信用积分</el-breadcrumb-item>
      <el-breadcrumb-item>特殊积分处理</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="平台" :label-width="formLabelWidth">
          <el-select v-model="platform" filterable clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in plateList"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model="shopname" autocomplete="on" size="small" clearable></el-input>
        </el-form-item>

        <el-form-item label="处理时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="searchformDate"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            :picker-options="pickerOptions"
            size="small"
            :clearable="false"
            >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="举报ID" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model="reportid" autocomplete="on" size="small" clearable></el-input>
        </el-form-item>

        <el-form-item label="经销商名称" :label-width="formLabelWidth">
          <el-select
            placeholder="请选择"
            v-model="dealerid"
            autocomplete="on"
            size="small"
            clearable
          >
            <el-option
              v-for="(item,i) in dealData"
              :key="i"
              :label="item.dealername"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>

    <div class="page">
      <div class="downBtn" v-if="logintype == 'SHOP' || logintype == 'DEALER'">
        <el-button size="small" type="primary" @click="downLoadDataClick" :loading="LoadData">下载数据</el-button>
      </div>
      <div class="downBtn" v-else>
        <el-button size="small" type="primary" @click="newAdd()" icon="el-icon-plus">新增</el-button>
        <el-button size="small" @click="onOpenDeleteDia(2)">批量删除</el-button>
        <el-button size="small" @click="downLoadDataClick" :loading="LoadData">下载数据</el-button>
        <el-button size="small" @click="downloadSpecialReportTemplat" :loading="LoadReportTemplat">导入模板下载</el-button>
        <el-button size="small" @click="BulkImportShow = true" :loading="LoadData">批量导入</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        ref="multipleTable"
        v-loading="dataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @row-click="detailsDrawer"
        style="width: 100%;"
        >
        <el-table-column type="selection" min-width="5%" v-if="logintype != 'SHOP' && logintype != 'DEALER'">
        </el-table-column>

        <el-table-column label="序号" type="index" min-width="10%">
        </el-table-column>

        <el-table-column label="违规信息" min-width="30%">
          <template slot-scope="scope">
            <span>
              <img
                :src="require('@/assets/img/platform/pla_'+scope.row.platform_code+'.png')"
                alt
                class="edit_icon vertical_middle"
                v-if="scope.row.platform_code"
              />
              {{ scope.row.shopname }}({{scope.row.reportid}})
            </span>
            <div>
              <span style="color: #00000072;">
                积分变化：
              </span>
              {{scope.row.points | opposite}}
            </div>
            <div>
              <span style="color: #00000072;">
                处理时间：
              </span>
              {{scope.row.pointtime | fullTime}}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="补充说明/举证材料" min-width="40%">
          <template slot-scope="scope">
            <div class="threeHa">
              <span style="color: #00000072;">
                补充说明：
              </span>
              {{scope.row.explain}}
            </div>
            <div>
              <span style="color: #00000072;">
                举证材料：
              </span>
              <span v-for="(item,index) in scope.row.reportpic.split(',')">
                <el-link
                  v-if="item"
                  type="primary"
                  :href="item"
                  target="_blank"
                  :key="item"
                  :underline="false"
                  @click.native.stop>
                  {{item.indexOf('_')>-1?item.slice(item.indexOf('_')+1):item.slice(item.indexOf('ceshi')+6)}}
                </el-link>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="15%" v-if="logintype != 'SHOP' && logintype != 'DEALER'">
          <template slot-scope="scope">
            <div class="g-inline-block" style="color: #108cee;cursor: pointer;float: left;margin-right: 10px;" @click.stop="newAdd(scope.row)">
              <i class="el-icon-edit-outline"></i>
              <span class="g-inline-block">编辑</span>
            </div>
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;" @click.stop="onOpenDeleteDia(1,scope.row.id)">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length >= 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 删除 -->
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
            <div>
              <div style="font-size: 16px;">
                你确认要删除<span>{{delType}}</span>违规信息吗？
              </div>
              <div style="font-size: 14px;">删除后
                <span style="color: #e90e24;font-size: 14px;">
                  违规信息将无法恢复
                </span>
              </div>
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
          <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 下载数据 -->
      <el-dialog
  			:title="editorTitle"
  			:visible.sync="downDataDialog"
  			:close-on-click-modal="false"
  			width="640px">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form label-width="100px">
  						<el-form-item label="平台：" :required="true">
                <el-select v-model="downData.platformCode" size="small" clearable placeholder="请选择" style="width: 440px;" @change="GetListBMC">
                  <el-option
                    v-for="item in plateList"
                    :key="item.dictCode"
                    :label="item.dictName"
                    :value="item.dictCode">
                  </el-option>
                </el-select>
  						</el-form-item>
              <el-form-item label="店铺名称：" :required="true">
                <el-select v-model="downData.shopid" filterable size="small" clearable placeholder="请选择" style="width: 440px;" @change="shopChange">
                  <el-option
                    v-for="item in shopData"
                    :key="item.id"
                    :label="item.shopName"
                    :value="item.id">
                  </el-option>
                </el-select>
  						</el-form-item>
  						<el-form-item label="扣分/加分：" :required="true">
                <el-radio-group v-model="ispoint" style="width: 440px;">
                  <el-radio label="false">扣分</el-radio>
                  <el-radio label="true">加分</el-radio>
                </el-radio-group>
  						</el-form-item>
              <el-form-item label="扣分分值：" :required="true">
                <el-input placeholder="请输入" v-model="downData.point" v-limitInput size="small" clearable></el-input>
  						</el-form-item>
              <el-form-item label="举证材料：" prop="reportpic">
                <el-upload
  								class="upload-demo"
  								name="file"
  								:with-credentials="true"
  								action="/hcm/hcmWorkOrder/headUpload"
  								:on-remove="handleRemove"
  								:on-success="handleUploadSuccess"
  								:before-upload="beforeUpload"
  								multiple
  								:file-list="fileList"
                  :data="uploadType">
  								<el-button size="small" plain  ><i class="el-icon-upload el-icon--right"></i>点击上传</el-button>
  								<div slot="tip" style="color:#999" class="el-upload__tip">
  									支持拓展名: .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .png格式,附件单个上传大小限制50M
  								</div>
  							</el-upload>
              </el-form-item>
              <el-form-item label="补充说明：">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="downData.explain">
                </el-input>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" class="g-confirm-btn" :loading="downloadLoading" @click="determine" type="primary">确 定</el-button>
  				<el-button size="small" class="g-cancel-btn" @click="downDataDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
    </div>
  </div>
  <el-drawer
    :title="'【' + drawerData.reportid + '】' + this.$options.filters['platformChinese'] (drawerData.platform_code) + '    ' +drawerData.shopname"
    :visible.sync="drawer"
    size="840px">
    <el-card class="margin_bottom20 no_margin">
      <el-form label-width="100px">
        <el-form-item label="举报ID：" >
          <span>{{drawerData.reportid}}</span>
        </el-form-item>
        <el-form-item label="平台：" >
          <span>{{drawerData.platform_code|platformChinese}}</span>
        </el-form-item>
        <el-form-item label="店铺名称：" >
          <span>{{drawerData.shopname}}</span>
          <span v-if="drawerData.shoptype == 1" style="
            font-size: 14px;
            color: #fff;
            border-radius: 3px;
            padding: 0 3px;
            height: 20px;
            line-height: 20px;
            margin: 0 0 0 5px;
            background: #52c41a;">
            授权店铺
          </span>
          <span v-if="drawerData.shoptype == 2" style="
            font-size: 14px;
            color: #fff;
            border-radius: 3px;
            padding: 0 3px;
            height: 20px;
            line-height: 20px;
            margin: 0 0 0 5px;
            background: #d4d4d4;">
            灰名单
          </span>
          <span v-if="drawerData.shoptype == 3 || drawerData.shoptype == 4" style="
            font-size: 14px;
            color: #fff;
            border-radius: 3px;
            padding: 0 3px;
            height: 20px;
            line-height: 20px;
            margin: 0 0 0 5px;
            background: #333333;">
            黑名单
          </span>
        </el-form-item>
        <el-form-item label="旺旺：" >
          <span>{{drawerData.wangwang}}</span>
        </el-form-item>
        <el-form-item label="积分变化：" >
          <span>{{drawerData.points | opposite}}</span>
        </el-form-item>
        <el-form-item label="举证材料：" >
          <div v-for="(item,index) in reportpicArr">
            <el-link
              v-if="item"
              type="primary"
              :href="item"
              target="_blank"
              :key="item"
              :underline="false">
              {{item.indexOf('_')>-1?item.slice(item.indexOf('_')+1):item.slice(item.indexOf('ceshi')+6)}}
            </el-link>
          </div>
        </el-form-item>
        <el-form-item label="补充说明：" >
          <div style="word-wrap: break-word;word-break: normal;">
            {{drawerData.explain}}
          </div>
        </el-form-item>
        <el-form-item label="处理人：" >
          <span>{{drawerData.pointhandle}}</span>
        </el-form-item>
        <el-form-item label="处理时间：" >
          <span>{{drawerData.pointtime | fullTime}}</span>
        </el-form-item>
      </el-form>
    </el-card>
  </el-drawer>
  <el-dialog title="批量导入"
    class="importModal"
    :visible.sync="BulkImportShow"
    :close-on-click-modal="false"
    width="640px"
    style="margin-top: 10%;" id="dialog">
    <div class="wrap" style="margin: 10px;">
      <el-upload
        ref="newupload"
        class="upload-demo"
        drag
        action="hcm/hcmReport/readExcelFile"
        :auto-upload="false"
        multiple
        :before-upload="beforeUpload2"
        accept=".xls,.xlsx"
        :on-success="confirmUpload"
        >
        <i class="el-icon-upload" style="color: #BDA571;"></i>
        <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
          <br>
          <span style="font-size: 14px;color: #d4d4d4;">
            支持扩展名：.xls .xlsx
          </span>
        </div>
      </el-upload>
      <div v-if="responseData.length != 0">
        <div style="font-size: 14px;color: #303133;line-height: 24px;margin: 12px 0;">
          失败扣分列表
        </div>
        <el-table
          :data="responseData"
          style="width: 100%">
          <el-table-column
            prop="platformCode"
            label="平台">
            <template slot-scope="scope" >
              <div>
                {{scope.row.platformCode | platformChinese}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="shopname"
            label="店铺名称">
          </el-table-column>
          <el-table-column
            prop="point"
            label="扣分/加分">
          </el-table-column>
          <el-table-column
            prop="err_info"
            label="错误说明">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
      <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  import { getLoginType } from "@/libs/until";
  import axios from 'axios'
  export default {
    data() {
      return {
        uploadType: {
  				tong: 'specialTreatment'
  			},
        responseData: [],
        bulLoading: false,
        BulkImportShow: false,
        reportpicArr: [],
        drawer: false,
        editorTitle: "",
        editorId: "",
        pointsid: "",
        uploadFileList: [],
        fileList: [],
        reportpic: "",
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        reportid: '',
        dealerid: '',
        LoadData: false,
        LoadReportTemplat: false,
        shopData: [],
        downDataDialog: false,
        downloadLoading: false,
        ispoint: 'false',
        downData: {
          platformCode: '',
          shopname: '',
          shopid: '',
          shoptype: '',
          point: '',
          explain: '',
          wangwang: '',
        },
        delType: '',
        checkAll: '',
        ficationLoading: false,
        deleteShow: false,
        dataLoading: false,
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        selectRows: [],
        searchformDate: [],
        delIds: [],
        totalNum: 100,
        formLabelWidth: '100px',
        openNumber: 0,
        platform: '',
        shopname: '',
        drawerData: [],
        plateList: [],
        logintype: getLoginType(),
        dealData: [],
      }
    },
    filters: {
      // 正变负负变正
      opposite: function(value) {
        let newValue
        if (value) {
          if(value.indexOf('-') != -1) {
            newValue = value.slice(1)
          } else {
            newValue = '-' + value
          }
          return newValue
        }
      },
    },
    created(){
  		this.getRecentDate();
  	},
    mounted() {
      this.getlistOfBmc()
      this.GetList()
      this.theQuery()
    },
    methods: {
      getlistOfBmc() {
        //初始化
        fetch({
          url: "hcm/dealer/getlistOfBmc",
          method: "get",
        }).then(res => {
          if (res.status == "10000") {
            this.dealData = res.data
          }
        });
      },
      BulkImport() {
        this.bulLoading = true
        this.$refs.newupload.submit();
        this.responseData = []
      },
      BulkImportShowf() {
        this.BulkImportShow = false
        this.$refs.newupload.clearFiles();
        this.responseData = []
      },
      confirmUpload(response) {
        if (response.status == 10000) {
          if (response.data && response.data.length > 0) {
            this.$message({
              message: response.message,
              type: 'warning'
            });
            this.responseData = response.data
          } else {
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.BulkImportShow = false
          }
          this.bulLoading = false
          this.$refs.newupload.clearFiles();
          this.theQuery();
        } else {
          this.bulLoading = false
          this.theQuery();
          this.BulkImportShow = false
          this.$message.error(response.message);
          this.$refs.newupload.clearFiles();
        }
      },
      beforeUpload2(file) {
        let Xls = file.name
        if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
          return file
        }else {
          this.$message.error('上传文件只能是 xls/xlsx 格式!')
          return false
        }
      },
      GetList() {
        let params={
          dictcode: 'platform',
        }
        fetch({
          url: "hcm/sys/GetList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.plateList = data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 详情
      detailsDrawer(row) {
        console.log(row)
        this.drawerData = []
        this.drawerData = row
        this.reportpicArr = this.drawerData.reportpic.split(',')
        console.log(this.reportpicArr)
        this.drawer = true
      },
      // 店铺数据处理
      shopChange() {
        for (let a in this.shopData) {
          if (this.downData.shopid == this.shopData[a].id) {
            this.downData.shopname = this.shopData[a].shopName
            this.downData.shoptype = this.shopData[a].shoptype
            this.downData.wangwang = this.shopData[a].wangwang
          }
        }
      },
      // 新增确定
      determine() {
        if (!this.downData.platformCode) {
          this.$message({
            message: '请选择平台',
            type: 'warning'
          });
          return
        }
        if (!this.downData.shopname) {
          this.$message({
            message: '请选择店铺名称',
            type: 'warning'
          });
          return
        }
        if (!this.downData.point) {
          this.$message({
            message: '请填写扣分分值',
            type: 'warning'
          });
          return
        }
        // if (this.uploadFileList.length == 0) {
        //   this.$message({
        //     message: '请上传举证材料',
        //     type: 'warning'
        //   });
        //   return
        // }

        this.downloadLoading = true
        let data = this.downData
        data.reportpic = this.uploadFileList.join(',')
        let url
        if (this.editorId != '') {
          // 编辑
          url = 'hcm/hcmReport/updateSpecialReport'
          data.id = this.editorId
          data.pointsid = this.pointsid
        } else {
          // 新增
          url = 'hcm/hcmReport/insertSpecialReport'
        }
        if (this.ispoint == 'true') {
          data.point = '-' + this.downData.point
        } else {
          data.point = this.downData.point
        }
        let that = this
        axios({
          method: 'post',
          url: url,
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          },
          data: data,
        }).then(function (response) {
          if (response.data.status == "10000") {
            that.downDataDialog = false
            that.downloadLoading = false
            that.$message({
              type: "success",
              message: "成功!"
            });
            that.theQuery()
          } else {
            that.downDataDialog = false
            that.downloadLoading = false
            that.$message.error(response.data.message)
          }
        })
      },
      handleRemove(file, fileList) {
  			let res = [];
  			for(let i of fileList) {
  				res.push(i.response.data.data);
  			}
  			this.uploadFileList = res;
  		},
      handleUploadSuccess(res) {
        if (res.data.data.indexOf('jpg') != -1 || res.data.data.indexOf('png') != -1 || res.data.data.indexOf('JPG') != -1 || res.data.data.indexOf('PNG') != -1) {
          console.log('是图片')
          this.uploadFileList.push('https://hawksights.obs.cn-east-2.myhuaweicloud.com/' + res.data.data)
          console.log(this.uploadFileList)
        } else if (res.data.data.indexOf('.pdf')!=-1){
          console.log('是PDF')
          this.uploadFileList.push('https://console.olonger.com/hcm/wechat/downLoadFilephone?filename=' + res.data.data);
  			} else {
          console.log('不是图片')
          this.uploadFileList.push('https://view.officeapps.live.com/op/view.aspx?src=https://hawksights.obs.cn-east-2.myhuaweicloud.com/' + res.data.data);
        }
  		},
      beforeUpload(file) {
  			let name = file.name;
  			let p = /\.(jpg|rar|zip|doc|docx|xls|xlsx|ppt|pptx|pdf|png)$/
  			if(!p.test(name)) {
  				this.$message({
  					showClose: true,
  					message: '请上传符合要求格式的文件',
  					type: 'warning'
  				});
  			}
  			let limitSize = 1 * 1024 * 1024 * 50;
  			if(file.size > limitSize) {
  				this.$message({
  					showClose: true,
  					message: '请上传大小小于50M的文件',
  					type: 'warning'
  				});
  			}
  			if(p.test(name) && file.size < limitSize) {
  				return true;
  			}
  			return false;
  		},
      // 下载数据
      downloadSpecialReportTemplat() {
        this.LoadReportTemplat = true
        fetch({
          url: "/hcm/hcmReport/downloadSpecialReportTemplat",
          method: "get",
          noFormat: true,
          responseType: "blob"
        })
        .then((res)=>{
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '特殊扣分处理模板.xlsx')
          document.body.appendChild(link)
          link.click()
          this.LoadReportTemplat = false
        })
      },
      // 下载数据
      downLoadDataClick() {
        this.LoadData = true
        let params={
          endtime: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10),
          starttime: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10),
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopname = this.shopname
        }
        if (this.reportid) {
          params.reportid = this.reportid
        }
        if (this.dealerid) {
          params.dealerid = this.dealerid
        }
        fetch({
            url: "/hcm/hcmReport/downloadSpecialReportPage",
            method: "get",
            params:params,
            noFormat: true,
            responseType: "blob"
        })
        .then((res)=>{
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '特殊积分处理.xlsx')
          document.body.appendChild(link)
          link.click()
          this.LoadData = false
        })
      },
      getRecentDate(picker,n){
        if (!n) {
          n = 90
        }
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = end;
          this.searchformDate[0] = end;
        } else {
          this.searchformDate[0] = start;
          this.searchformDate[1] = end;
        }
  		},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery()
      },
      // 数据源
      theQuery() {
        this.dataLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          endtime: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10),
          starttime: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10),
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopname = this.shopname
        }
        if (this.reportid) {
          params.reportid = this.reportid
        }
        if (this.dealerid) {
          params.dealerid = this.dealerid
        }
        fetch({
          url: "hcm/hcmReport/getSpecialReportPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataLoading = false
            this.tableData = res.data.content
            this.totalNum = res.data.totalElements
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },

      // 序号勾选
      handleSelectionChange(val) {
        this.openNumber = val.length;
        this.selectRows = val;
      },
      // 勾选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      // 删除
      onOpenDeleteDia(e,ids) {
        this.delIds = ''
        if (ids && e == 1) {
          this.delType = '该'
          this.delIds = ids
        } else if (this.checkAll == 2 && e == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          this.delType = this.openNumber + '条'
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.deleteShow = true
      },
      // 取消删除
      delCancel() {
        this.deleteShow = false
        this.delType = ''
        this.checkAll = ''
        this.delIds = ''
      },
      // 确认删除
      deleteClassification() {
        this.ficationLoading = true
        let params = {
          ids: this.delIds,
          endtime: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10),
          starttime: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10),
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopname = this.shopname
        }
        if (this.reportid) {
          params.reportid = this.reportid
        }
        if (this.dealerid) {
          params.dealerid = this.dealerid
        }
        fetch({
          url: "/hcm/hcmReport/deleteSpecialReportPage",
          method: "post",
          data: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ficationLoading = false
            this.deleteShow = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.theQuery();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 新增/编辑
      newAdd(data) {
        // 有data就是编辑
        if (data) {
          this.downData.platformCode = data.platform_code
          this.downData.shopname = data.shopname
          this.downData.shopid = data.shopid
          this.downData.shoptype = data.shoptype
          this.downData.point = data.points
          this.downData.wangwang = data.wangwang
          if (data.points.indexOf('-') != -1) {
            var str = this.downData.point
            this.downData.point = str.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
            this.ispoint = 'true'
          }
          this.uploadFileList = data.reportpic.split(',')
          this.downData.explain = data.explain
          this.editorId = data.id
          this.pointsid = data.pointsid
          this.editorTitle = '编辑'
          this.GetListBMC()
        } else {
          this.editorId = ''
          this.pointsid = ''
          this.editorTitle = '新增'
          this.downData.platformCode =  ''
          this.downData.shopname =  ''
          this.downData.shopid =  ''
          this.downData.shoptype =  ''
          this.downData.point =  ''
          this.downData.explain =  ''
          this.downData.wangwang =  ''
        }
        this.downDataDialog = true
      },
      // 根据平台筛选店铺
      GetListBMC() {
        let params = {
          platformCode: this.downData.platformCode
        }
        fetch({
          url: "hcm/hcmShop/GetListBMC",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.shopData = data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },

    },
    components: {
      pagination
    }
  }
</script>
<style lang="scss">
  #specialTreatment{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }
    .shoptype {
      display: inline-flex;
    	align-items: center;
    	font-size: 14px;
    	color: #fff;
    	border-radius: 3px;
    	padding: 0px 3px;
    	height: 20px;
    	line-height: 20px;
    	margin: 0 0 0 5px;
    	vertical-align: super;
    	 background: #d4d4d4;
    	&.type{
    		background: #d4d4d4;
    	}
      &.type1 {
        background: #52c41a;
      }
      &.type2 {
        background: #d4d4d4;
      }
      &.type3 {
        background: #333333;
      }
      &.type4{
    	background: none;
      }
    }
    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .downBtn {
      display: flex;
      justify-content: flex-start;
    }
    .prompt {
      height: 28px;
      border: 1px solid #108cee;
      background-color: #e6f7ff;
      border-radius: 5px;
      line-height: 28px;
      margin-top: 8px;
      margin-bottom: 8px;
    }
    .promptFont{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
    }
    .promptFont2{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
      cursor: pointer;
    }
    .plat-item {
    	display: inline-block;
    	margin-left: 5px;
    	border: 1px solid rgb(164, 163, 163);
    	padding: 2px;
      border-radius: 4px;
    }
    .threeHa {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
</style>
